import type { ReactNode } from 'react';
import type { Product } from '@/types';
import { ProductCard } from '@/components/ProductCard';

export function ProductGrid({
  products,
  five = false,
  compact = false,
  leading,
}: {
  products: Product[];
  five?: boolean;
  /** Halves the sale-photo size (home + shop grids). Product detail keeps full size. */
  compact?: boolean;
  /** Cards placed before the products in the same grid (a shop's packs), keyed by the caller. */
  leading?: ReactNode;
}) {
  return (
    <div
      className={`product-grid${five ? ' product-grid--5' : ''}${
        compact ? ' product-grid--compact' : ''
      }`}
    >
      {leading}
      {products.map((p) => (
        <ProductCard key={p.id} product={p} />
      ))}
    </div>
  );
}
